module.exports = __webpack_public_path__ + "static/media/Menu.73128ec9.svg";